
import { commonFunctions } from "../_utilities/commonFunctions";
import { config } from "../config";

export const signInService = {
    createSignIn,
    // getSignIn
}

function createSignIn(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    }
    const requestOptions = commonFunctions.getRequestOptions(
        "post",
        extraHeaders,
        JSON.stringify(data)
    );
    return fetch(
        `${config.localApiUrl}/api/verifyUser`,
        requestOptions
    ).then((response) => response.json())
}

// function getSignIn() {
//     const requestOptions = commonFunctions.getRequestOptions(
//         "GET",
//     )
//     return fetch(
//         `${config.localApiUrl}/api/getUserData`,
//         requestOptions
//     ).then((response) => response.json())
// }